import { render } from "./TestDetailView.vue?vue&type=template&id=32816127&scoped=true"
import script from "./TestDetailView.vue?vue&type=script&lang=js"
export * from "./TestDetailView.vue?vue&type=script&lang=js"

import "./TestDetailView.vue?vue&type=style&index=0&id=32816127&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32816127"]])

export default __exports__